export const getAccessToken = (state: IRootState) => state.user.access;
export const getRefreshToken = (state: IRootState) => state.user.refresh;

export const getClientId = (state: IRootState) => state.global.clientId;
export const getOfflineModeStatus = (state: IRootState) =>
    state.appState.isManualOffline;
export const getOfflineStatus = (state: IRootState) => state.global.isOffline;
